import React, {useState, useEffect} from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'

import buttonImg from '../../../static/images/modals/images/close.svg'

import Preferences from "../cookies/preferences/Preferences";

let customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgb(0, 31, 45, 0.8)',
        zIndex: 20,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '65%',
        padding: '0px',
        borderRadius: '2px',
        height: '80%',
        marginTop: '40px',
    }
};

Modal.setAppElement('body')

const ModalCookies = ({modalState, setModalState, setCookies, cookies}) => {
    // const [width, setWidth] = useState(window.innerWidth)

    useEffect(() => {
        // const handleResize = () => setWidth(window.innerWidth)
        document.body.style.height = "100%";
        document.body.style.overflowY = "unset";
        // window.addEventListener("resize", handleResize)
        // if (width < 1200) {
        //     console.log(width)
        //     customStyles['content']['height'] = 'auto';
        //     customStyles['content']['maxWidth'] = '90%';
        //     customStyles['content']['top'] = '45%';
        // } else
        //     customStyles['content']['height'] = 'auto';
        // return () => {
        //     window.removeEventListener("resize", handleResize)
        // }
    });

    function closeModal() {
        setModalState(false);
        document.body.style.height = "unset";
        document.body.style.overflowY = "unset";
    }

    return (
        <ModalCookiesStyle>
            <Modal
                isOpen={modalState}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel={'update'}
                shouldCloseOnOverlayClick={true}
                className="modal-stay-updated"
            >
                <PaddingModal>
                    {/*<CloseModal onClick={() => closeModal()}>*/}
                    {/*    <ButtonImage/>*/}
                    {/*</CloseModal>*/}
                    {/*<Cookies isModal/>*/}
                    <Preferences  setModalState={setModalState} setCookies={setCookies} cookies={cookies} closeModal={closeModal}/>
                </PaddingModal>
            </Modal>
        </ModalCookiesStyle>
    )
}

export default ModalCookies

const ModalCookiesStyle = styled.div`
  position: relative;
  @media ${({theme}) => theme.breakpoints.mobile} {
    margin-top: 10rem;
    overflow-y: auto;
    padding-left: 1.4rem;
    padding-right: 1.4rem;
  }
`

// const CloseModal = styled.button`
//   z-index: 5;
//   border: none;
//   position: absolute;
//   top: 4rem;
//   right: 4rem;
//   background: none;
//   @media ${({theme}) => theme.breakpoints.mobile} {
//     top: 2rem;
//     right: 1rem;
//   }
// `

const ButtonImage = styled.div`
  background-image: url(${buttonImg});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 2.4rem;
  height: 2.4rem;
`

const Wrapper = styled.div`
`

const PaddingModal = styled.div`
  height: 100%;
  //padding: 6rem 20rem 9.4rem 20rem;
  @media ${({theme}) => theme.breakpoints.mobile} {
    padding-top: 4rem;
    padding-left: 2.4rem;
    padding-right: 2.4rem;
    padding-bottom: 4rem;
  }
`
